<template lang="pug">
.page 
    PnlChart(:pnlData="data")
    a-modal(v-model="addFee.visible" title="添加手续费" @ok="handleSumitAddFee")
        a-form
            a-form-item(label="Date")
                div {{addFee.date}}
            a-form-item(label="Fee")
                a-input-number(v-model="addFee.fee" style="width: 100%")
            a-form-item(label="Other Fee" v-if="bookName == 'YuanFamilyOffice 1'")
                a-input-number(v-model="addFee.other_fee" style="width: 100%")

    .ctl-bar
        a-button(type="primary" @click="getData") Refresh
        a-button(type="primary" @click="exportDataCSV" style="margin-left: 10px") Export
        a-button(type="primary" @click="gotoHKProductDown" style="margin-left: 10px") 估值表下载

    a-table(:columns="columns" :dataSource="data" size="small" :pagination="{ pageSize: 20 }" row-key="date" :loading="loading")
        template(slot="add_fee" slot-scope="record")
            a-button(type="primary" @click="handleAdd(record)" size="small" icon="plus") Add
</template>

<script>
import _ from 'lodash';
import PnlChart from './PnlChart.vue';

export default {
    props: ['bookName', 'isAdmin'],
    data() {
        let cols = [
                {
                    title: 'Date',
                    key: 'date',
                    dataIndex: 'date',
                },
                {
                    title: 'OTC Daily Pnl',
                    key: 'otc_daily_pnl',
                    dataIndex: 'otc_daily_pnl',
                },
                {
                    title: 'OTC Total Pnl',
                    key: 'otc_total_pnl',
                    dataIndex: 'otc_total_pnl',
                },
                {
                    title: 'LongShort Daily Pnl',
                    key: 't0_daily_pnl',
                    dataIndex: 't0_daily_pnl',
                },

                {
                    title: 'LongShort Total Pnl',
                    key: 't0_total_pnl',
                    dataIndex: 't0_total_pnl',
                },
                {
                    title: 'Daily Pnl',
                    key: 'daily_pnl',
                    dataIndex: 'daily_pnl',
                },
                {
                    title: 'Total Pnl',
                    key: 'total_pnl',
                    dataIndex: 'total_pnl',
                },
                
            ];
        if (this.bookName == 'YuanFamilyOffice 1') {
            cols.push({
                title: 'Other Daily Pnl',
                key: 'other_daily_pnl',
                dataIndex: 'other_daily_pnl',
            });
            cols.push({
                title: 'Other Pnl',
                key: 'other_total_pnl',
                dataIndex: 'other_total_pnl',
            });
            cols.push({
                title: 'Other Fee',
                key: 'manual_other_fee',
                dataIndex: 'manual_other_fee',
            })
        }

        cols.push({
            title: 'Fee',
            key: 'manual_fee',
            dataIndex: 'manual_fee',
        });
        cols.push({
            title: 'Daily NAV',
            key: 'daily_nav',
            dataIndex: 'daily_nav',
        });
        
        cols.push({
            title: 'NAV',
            key: 'nav',
            dataIndex: 'nav',
        });

        cols.push({
            title: 'Simple NAV',
            key: 'simple_nav',
            dataIndex: 'simple_nav',
        })

        if (this.isAdmin) {
            cols.push({
                title: 'Add Fee',
                key: 'add_fee',
                scopedSlots: {customRender: 'add_fee'}
            })
        }
        
        return {
            data: [],
            columns: cols,
            loading: false,
            addFee: {
                visible: false,
                date: '',
                fee: 0,
                other_fee: 0,
            },
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        gotoHKProductDown() {
            this.$router.push({
                name: 'folders',
                params: {
                    group: 'HK产品结算单',
                }
            });
        },
        exportDataCSV() {
            let header = ['Date', 'OTC Daily Pnl', 'OTC Total Pnl', 'LongShort Daily Pnl', 'LongShort Total Pnl', 'Daily Pnl', 'Total Pnl', 'Daily NAV', 'NAV', 'Simple NAV'];
            let csv = header.join(',') + '\n';
            _.forEach(this.data, item => {
                let row = [
                    item.date,
                    item.otc_daily_pnl,
                    item.otc_total_pnl,
                    item.t0_daily_pnl,
                    item.t0_total_pnl,
                    item.daily_pnl,
                    item.total_pnl,
                    item.daily_nav,
                    item.nav,
                    item.simple_nav
                ];
                csv += row.join(',') + '\n';
            });
            let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${this.bookName}_pnl.csv`);
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                URL.revokeObjectURL(url);
                
            }, 100);

        },
        getData() {
            this.loading = true;
            this.$api.request('GET', `hkoption/${this.bookName}/hkproductPnl`).then(res => {
                let data = [];
                let total_pnl = 0;
                let otc_total_pnl = 0;
                let t0_total_pnl = 0;
                let other_total_pnl = 0;

                let nav = 0;
                let simple_nav = 0;
                let last_aum = _.last(res.data).aum;
                let started = false;

                _.forEach(res.data, item => {
                    let t0_daily_pnl = item.t0_daily_pnl*item.t0Weight - item.manual_fee;
                    let otc_daily_pnl = item.otc_daily_pnl - item.otc_manual_fee;
                    let other_daily_pnl = (item.other_daily_pnl || 0) - (item.manual_other_fee || 0);
                    let daily_pnl = otc_daily_pnl + t0_daily_pnl + other_daily_pnl ;
                    let daily_nav = daily_pnl / item.aum;
                    
                    if (!started && t0_daily_pnl === 0 && otc_daily_pnl === 0 && other_daily_pnl === 0) {
                        return;
                    }
                    started = true;

                    total_pnl += daily_pnl;
                    otc_total_pnl += otc_daily_pnl;
                    t0_total_pnl += t0_daily_pnl;
                    nav += daily_nav;
                    simple_nav += (daily_pnl || 0) / last_aum;
                    other_total_pnl += other_daily_pnl;

                    data.push({
                        date: item.date,
                        otc_daily_pnl: Math.round(otc_daily_pnl*1000)/1000,
                        daily_pnl: Math.round(daily_pnl*1000)/1000,
                        t0_daily_pnl: Math.round(t0_daily_pnl*1000)/1000,
                        t0_total_pnl: Math.round(t0_total_pnl*1000)/1000,
                        otc_total_pnl: Math.round(otc_total_pnl*1000)/1000,
                        total_pnl: Math.round(total_pnl*1000)/1000,
                        other_daily_pnl: Math.round(other_daily_pnl*1000)/1000,
                        other_total_pnl: Math.round(other_total_pnl*1000)/1000,
                        daily_nav: Math.round(daily_nav*100000)/100000,
                        nav: Math.round(nav*100000)/100000,
                        simple_nav: Math.round(simple_nav*100000)/100000,
                        manual_fee: Math.round(item.manual_fee*1000)/1000,
                        manual_other_fee: Math.round(item.manual_other_fee*1000)/1000,
                    });
                });
                this.data = data;
                this.loading = false;
            });
        },
        handleAdd(record) {
            this.addFee = {
                visible: true,
                date: record.date,
                fee: record.manual_fee,
                other_fee: record.manual_other_fee,
            };
        },
        handleSumitAddFee() {
            this.$api.request('POST', 'hkoption/manualFee/'+this.bookName, {
                date: this.addFee.date,
                fee: this.addFee.fee,
                other_fee: this.addFee.other_fee,
            })
            .then(res => {
                this.addFee.visible = false;
                this.getData();
            })
        }
    },
    components: {
        PnlChart
    }
}
</script>